import { render, staticRenderFns } from "./AeTextarea.vue?vue&type=template&id=33b978f4&scoped=true"
import script from "./AeTextarea.vue?vue&type=script&lang=js"
export * from "./AeTextarea.vue?vue&type=script&lang=js"
import style0 from "./AeTextarea.vue?vue&type=style&index=0&id=33b978f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b978f4",
  null
  
)

export default component.exports